// Define the new options
$(function() {
	var newOptions = $('.pl_formation_centre_program_info_title_wrp > h4');
	var dropdown = $('#pl_formation_centre_dropdown');
	if (newOptions && dropdown) {
		$('#pl_formation_centre_dropdown').append(
			$('<option>', {
				value: '0',
				text: 'Todos'
			})
		);
		// Loop through the new options and add them to the select element
		$.each(newOptions, function(key, value) {
			dropdown.append(
				$('<option>', {
					value: parseInt(key) + 1,
					text: value.innerText
				})
			);
		});
		// Add event listener to select element
		dropdown.on('change', function() {
			// Get the selected value
			var selectedValue = $(this).val();
			var elementSelected = $('.pl_formation_centre_js_' + selectedValue);
			if (selectedValue > 0 && elementSelected) {
				hideAll();
				$(elementSelected).show();
			} else {
				showAll();
			}
		});

		// Select the first option by default
		dropdown.val($('#pl_formation_centre_dropdown option:first').val());
	}

	function hideAll() {
		$.each($('.pl_formation_centre_program_info_wrapper'), function() {
			$(this).hide();
		});
	}
	function showAll() {
		$.each($('.pl_formation_centre_program_info_wrapper'), function() {
			$(this).show();
		});
	}
});
